import React, {useEffect} from 'react'
import {Col, Row} from "reactstrap";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {connect} from "react-redux";


// components
import FbMediaConfigList from "./_list";
import FbMediaConfigForm from "./_form";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// actions
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {clearState, setApp, setUdn} from "../../../redux/actions/generalActions/mainActions";


const FbMediaConfig = props => {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);


    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);


    const createItem = () => {
        props.setForm();
        ModalFormContainer(FbMediaConfigForm);
    }


    return <>
        {loading && showLoader()}
        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    <div className="ml-auto paddingAdd">
                        <ButtonNew onClick={createItem}/>
                    </div>
                </div>
            </Col>
            <Col md="12">
                <FbMediaConfigList/>
            </Col>
        </Row>
    </>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    clearState,
    clearListState,
    setUdn,
    setApp,
    setForm,
});

export default connect(mapStateToProps, mapActionsToProps)(FbMediaConfig)